import type { FaireProductEntity } from "../../entity_types/product";

export const p_em6ay7my7u: FaireProductEntity = {
  token: "p_em6ay7my7u",
  type: "product",
  name: "Colombo Coffee Dripper / Pour Over",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/502b5b45f8b5f94b9ee29d5a233dc498fd54ee3ebf756eac1a17ae1c8acdcf82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62f126ea353bf08b4a097b234b1bd660aaf3a144264536f4cac7b68d7ab78b11.jpeg",
    "https://cdn.faire.com/fastly/7b6b6de0c90fc9349fc37d1907d1a4e68493ca050bd545e09033adcaaaa698cc.jpeg",
    "https://cdn.faire.com/fastly/d458b1d94d2f45e00d9834b3d137f86f60e014e10cad6e4980a0d9d58e5f06e9.jpeg",
    "https://cdn.faire.com/fastly/73bcfa24222fa330649ddb34e79673ba10ba71a77e5319e66f31086d12e3de4b.jpeg",
    "https://cdn.faire.com/fastly/8f0d2c7fb904cd6f9bef8cfac6245faaf493d6a6f240f6836d65ecdb8ec75b04.jpeg",
  ],
  priceDollars: 20,
  description:
    "COLOMBO coffee dripper has been designed to enrich your daily coffee ritual. Made for use with standard size 2 paper filters, it fits perfectly on Aaron Probyn COLOMBO, NEU, or any favourite mug for a generous single cup. Crafted from high-fired coloured porcelain with a tactile unglazed exterior and smooth, glazed interior, the dripper is made to last and to be used, every day.\n\n• Material: Porcelain\n• Size: Ø10.6 x 8.6cm / Ø4.2” x 3.4”\n• Set of 2\n\n• Suitable to use with size 2 paper filter.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:30.771Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
